import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatCheckboxChange } from '@angular/material/checkbox';
import { NextcloudFile } from 'src/app/classes';
import { NextcloudExplorerComponentService } from './nextcloud-explorer-component-service';

@Component({
  selector: 'app-nextcloud-explorer',
  templateUrl: './nextcloud-explorer.component.html',
  styleUrls: ['./nextcloud-explorer.component.css'],
  providers: [
    NextcloudExplorerComponentService
  ]
})
export class NextcloudExplorerComponent implements OnInit {

  @Input() enableNavigation: boolean = false;
  @Input() showFolderMetadata: boolean = false;
  @Input() singleSelectionMode: boolean = false;
  @Input() loading: boolean = false;

  @Input() set visibleTypes(types){
    this.nextcloudExplorerComponentService.setVisibleTypes(types);
  }

  @Input() enableSelection: boolean = true;

  filterControl = new FormControl();

  private _multipleSelectionPresetted: NextcloudFile[];
  @Input() set multipleSelectionPresetted(value: NextcloudFile[]){
    this._multipleSelectionPresetted = value;
    if(this.files){
      for(let file of this.files) this.multipleSelectionMap[file.fileId] = this.multipleSelectionPresetted.includes(file);
    }
  }
  get multipleSelectionPresetted(): NextcloudFile[] {
    return this._multipleSelectionPresetted;
  }

  @Output() onFileClick: EventEmitter<NextcloudFile> = new EventEmitter();
  @Output() onFileDblClick: EventEmitter<NextcloudFile> = new EventEmitter();

  _files: NextcloudFile[];
  @Input() set files(files: NextcloudFile[]) {
    this.currentSelection = null;
    this.nextcloudExplorerComponentService.setFiles(files);
  }
  @Input() set filter(filter: string){
    this.filterControl.setValue(filter);
  }

  @Input() showEntryOptionMenus: boolean = false;

  @Output() emitRefresh: EventEmitter<void> = new EventEmitter();

  filterMatchingCount: number;

  _singleSelectionFile: NextcloudFile;
  set singleSelectionFile(file: NextcloudFile) {
    this._singleSelectionFile = file;
    this.singleSelectionChanged.emit(file);
  }
  get singleSelectionFile(): NextcloudFile {
    return this._singleSelectionFile;
  }

  multipleSelectionMap = { };

  @Output() singleSelectionChanged: EventEmitter<NextcloudFile> = new EventEmitter<NextcloudFile>();
  @Input() view: number = NextcloudExplorerComponentView.List;

  @Output() multipleSelectionChanged: EventEmitter<NextcloudFile[]> = new EventEmitter<NextcloudFile[]>();
  @Output() fileSelected: EventEmitter<string> = new EventEmitter();

  filterTimeout;

  _currentSelection: string = null;
  set currentSelection(value: string){
    this._currentSelection = value;
    this.fileSelected.next(value);
  }
  get currentSelection(): string {
    return this._currentSelection;
  }

  constructor(
    public nextcloudExplorerComponentService: NextcloudExplorerComponentService
  ) { }

  fileClick = (file: NextcloudFile) => {
    this.currentSelection = file.fileId;
    this.onFileClick.emit(file);
  }
  fileDblClick = (file: NextcloudFile) => this.onFileDblClick.emit(file);

  multipleSelection(event, file: NextcloudFile){
    if(this.multipleSelectionMap[file.fileId]) this.multipleSelectionMap[file.fileId] = false;
    else this.multipleSelectionMap[file.fileId] = true;
    this.multipleSelectionChanged.emit(this.files.filter(x => this.multipleSelectionMap[x.fileId]));
  }

  ngOnInit(): void {
    this.filterControl.valueChanges.subscribe((filter: string) => this.nextcloudExplorerComponentService.setFilter(filter));
  }

  refresh = () => this.emitRefresh.emit();

  singleSelection(event: MatCheckboxChange, file: NextcloudFile) {
    if (event.checked) this.singleSelectionFile = file;
    else this.singleSelectionFile = null;
  }

  // HELPER FOR NG VIEW COMPONENT
  get NextcloudExplorerComponentView() {
    return NextcloudExplorerComponentView;
  }

}

export const NextcloudExplorerComponentView = {
  "List": 1,
  "Tiles": 2
}
